import React from 'react';

interface ParameterControlsProps {
  temperature: number;
  onTemperatureChanged: (value: number) => void;
  maxTokens: number;
  onMaxTokensChanged: (value: number) => void;
}

const ParameterControls: React.FC<ParameterControlsProps> = ({
  temperature,
  onTemperatureChanged: setTemperature,
  maxTokens,
  onMaxTokensChanged: setMaxTokens,
}) => {
  return (
    <div className="parameter-controls">
      <div className="control-group">
        <label className="control-label">Temperature</label>
        <input
          type="number"
          className="number-input"
          value={temperature}
          onChange={(e) => setTemperature(parseFloat(e.target.value))}
          min={0}
          max={2}
          step={0.1}
        />
        <input
          type="range"
          className="range-slider"
          value={temperature}
          onChange={(e) => setTemperature(parseFloat(e.target.value))}
          min={0}
          max={2}
          step={0.1}
        />
      </div>

      <div className="control-group">
        <label className="control-label">Max tokens</label>
        <input
          type="number"
          className="number-input"
          value={maxTokens}
          onChange={(e) => setMaxTokens(parseInt(e.target.value))}
          min={1}
          max={2000}
          step={1}
        />
      </div>
    </div>
  );
};

export default ParameterControls;